import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  EnergyType,
  EnergyTypeValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesEnergy,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionEnergyDto } from './dto.type';

export class QuestionEnergyMapper {
  static dtoToEntity(dto: QuestionEnergyDto): ImpactCo2Answer<ValuesEnergy> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'ENERGY',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        energyType: validateValueInType<EnergyType>(
          dto.energyType,
          EnergyTypeValues,
        ),
        energyConsumptionQuantity: Number.parseFloat(
          dto.energyConsumptionQuantity.toString(),
        ),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesEnergy>,
    projectId: number,
  ): Omit<QuestionEnergyDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      energyType: answer.values.energyType,
      energyConsumptionQuantity: answer.values.energyConsumptionQuantity,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
